import { render } from "./BackgroundImage.vue?vue&type=template&id=f2c92476&scoped=true"
import script from "./BackgroundImage.vue?vue&type=script&lang=ts"
export * from "./BackgroundImage.vue?vue&type=script&lang=ts"

import "./BackgroundImage.vue?vue&type=style&index=0&id=f2c92476&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f2c92476"

export default script